module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_07-9f5995fc3fb94b20d9ec3deab1cb0d3c.jpg";